import { InjectionToken } from '@angular/core';

export const SOFTLINE_CONFIG_ARBEITSBERICHT = new InjectionToken<ArbeitsberichtConfig>(
  'TIME_REPORT_CONFIG'
);

export interface ArbeitsberichtConfig {
  clickAction?: 'select' | 'navigate';
  useSecondaryBorderStyle?: boolean;
  showGeodaten?: boolean;
  hideEntryInDetails?: boolean;
  allowDelete?: boolean;
  editableDaysBeforeToday?: number;
  editableWeeksBeforeToday?: number;
  /**
   * By default, the selected party gets persistent until the app is closed
   * This behavior can be disabled by setting this property to `true`
   * When `true` the selected persons will be reset immediately after creating an entry
   */
  resetPartyAfterCreate?: boolean;
  actions: {
    label: string;
    icon: string;
    actionType: 'scanOrder' | 'recentObjects';
  }[];
}
